import { Injectable, inject } from '@angular/core';
import { ConfigService, Endpoint } from '../../shared/services/config';
import { EncodingService } from '../../shared/services/encoding.service';

@Injectable({
  providedIn: 'root'
})
export class NomidioLoginService {
  private readonly encodingService = inject(EncodingService);
  private readonly configService = inject(ConfigService);

  public static readonly STATE_STORAGE_KEY = 'nomidio-login-state';

  public loginWithNomidio(): void {
    const baseUrl = this.configService.getEndpoint(Endpoint.OpenIdService);
    const clientId = this.configService.getNomidioLoginClientId();
    const responseType = 'code';
    const scope = 'openid email';
    const redirectUri = `${window.origin}/login`;
    const state = this.generateState();
    this.saveState(state);

    window.open(this.generateUrl(baseUrl, clientId, responseType, scope, redirectUri, state), '_self');
  }

  public isValidLogin(code: string, state: string): boolean {
    if (!code || !state) {
      return false;
    }
    const savedState = this.getState();
    return !!savedState && state === savedState;
  }

  private generateState(): string {
    const randomArray = window.crypto.getRandomValues(new Uint8Array(16));
    const buffer = Array.prototype.map.call(randomArray, function (charCode: number) {
        return String.fromCharCode(charCode);
    }).join('');
    const base64String = window.btoa(buffer);
    return this.encodingService.convertBase64toBase64Url(base64String);
  }

  private generateUrl(baseUrl: string, clientId: string, responseType: string, scope: string, redirectUri: string, state: string) {
    const oauthUrl = new URL(`${baseUrl}/oauth/authorize`);
    oauthUrl.searchParams.append('response_type', responseType);
    oauthUrl.searchParams.append('scope', scope);
    oauthUrl.searchParams.append('client_id', clientId);
    oauthUrl.searchParams.append('redirect_uri', redirectUri);
    oauthUrl.searchParams.append('state', state);
    return oauthUrl.toString();
  }

  private saveState(state: string): void {
    sessionStorage.setItem(NomidioLoginService.STATE_STORAGE_KEY, state);
  }

  private getState(): string | null {
    return sessionStorage.getItem(NomidioLoginService.STATE_STORAGE_KEY);
  }
}
